import { convertUTCDateInTimeZone } from "@taabl/common-lib/calculators/date";
import { CountryStateCodes } from "@taabl/common-lib/constants/CountryStateCodes";
import { round } from "@taabl/common-lib/utils";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  FormText,
  Row
} from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
//import { formatDate } from "../libs/utils";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { IconContext } from "react-icons/lib";
import { MdDeleteForever } from "react-icons/md";
import { toast } from "react-toastify";
import { usePlan } from "../../src/contexts/PlanContext";
import LoaderButton from "../components/LoaderButton";
import { Constants } from "../libs/Constants";
import { create, delObj, get, update } from "../libs/dbFunctions";
import { validateForms } from "../libs/hooksLib";
import { getConfig } from "../Objects/Object";
import "./EditObj.css";

export default function EditObj(props) {
  //useRef uses the browser to save the state,
  //as the state changes, it won't re-render the component
  const [obj, setObj] = useState(null);
  const [errors, setErrors] = useState(null);
  const { plan, loadPlan } = usePlan();
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState(null);
  const [config, setConfig] = useState({});
  const [id, setId] = useState(null);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    async function onLoad() {
      props.setPageLoading(true);
      let editObj = null;
      if (props.match && props.match.params) {
        editObj = JSON.parse(props.match.params.editObj);
      } else if (props.userObj) {
        editObj = props.userObj;
      }
      const t = editObj.type;
      const id = editObj.id;
      try {
        let typeConfig = getConfig(t);
        setConfig(typeConfig);
        await loadPlan(props.activeCompany.id);
        let obj = null;
        if (id) {
          if (t === Constants.dbTypes.PERIOD) {
            let itemKey = {
              companyId: props.activeCompany.id,
              key: id,
            };
            obj = await get(t, itemKey);
          } else {
            obj = await get(t, id);
          }
          if (t === Constants.dbTypes.USER) {
            let percent = calculatePercent(obj);
            if (percent) {
              obj = {
                ...obj,
                contributionPercent: percent,
              };
            }
          }
        } else {
          obj = typeConfig.empty;
          if (typeConfig.scope && typeConfig.scope !== "admin") {
            obj.companyId = props.activeCompany.id;
          }
        }
        setObj(obj);
        setType(t);
        setId(id);
      } catch (e) {
        toast.error(e);
      }
      props.setPageLoading(false);
    }
    onLoad();
  }, [props?.match?.params.editObj, props?.userObj, props?.activeCompany]);

  function calculatePercent(obj) {
    let percent = null;
    if (obj.contributionAmount && obj.salary && plan) {
      percent = round(
        (Number(obj.contributionAmount) / Number(obj.salary)) *
        ((12 / Number(plan?.purchasePeriod)) * 100)
      );
    }
    return percent;
  }
  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    setErrors(validateForms(obj, config.validationSchema, config.fieldTypes));
    if (
      type === Constants.dbTypes.OFFERING_PERIOD &&
      props.activeCompany.id === Constants.TaablAdminCompany
    ) {
      toast.error("Not allowed to create Period for TaablAdmin Company");
      setIsLoading(false);
    } else {
      if (!isEmpty) {
        try {
          console.log("creating Object:" + JSON.stringify(obj));
          obj.type = type;
          if (
            type === Constants.dbTypes.USER &&
            obj.salary &&
            obj.contributionPercent
          ) {
            obj.contributionAmount =
              (obj.salary * obj.contributionPercent) /
              ((12 / Number(plan.purchasePeriod)) * 100);
          }
          if (id) {
            obj.id = id;
            obj.activeCompanyId = props.activeCompany.id;
            await update(type, obj);
            if (type === Constants.dbTypes.COMPANY) {
              let company = await get(Constants.dbTypes.COMPANY, obj.id);
              props.setActiveCompany(company);
            }
          } else {
            if (type === Constants.dbTypes.USER)
              obj.email = obj.email.toLowerCase();
            if (
              type === Constants.dbTypes.COMPANY &&
              "totalShares" in obj &&
              obj.totalShares
            ) {
              obj.totalShares = Number(obj.totalShares);
            }
            await create(type, obj);
          }
          // Go to page from where it came
          props.history.goBack();
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error) {
            toast.error(e.response.data.error);
          } else {
            toast.error(e);
          }
          setIsLoading(false);
        }
      } else {
        toast.info("No changes to save.");
        setIsLoading(false);
      }
    }
  }

  function showConfirm(event) {
    event.preventDefault();
    if (!config.actionDelete) {
      return;
    }
    confirmAlert({
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelete(),
        },
        {
          label: "No",
          className: "btn-cancel",
        },
      ],
    });
  }

  async function handleDelete() {
    setIsLoading(true);
    let objType = type;
    let params = null;
    if (objType === Constants.dbTypes.PERIOD) {
      params = {
        periodStartdate: obj.periodStartdate,
        periodEnddate: obj.periodEnddate,
      };
    }
    try {
      await delObj(objType, obj.id, props.activeCompany.id, params);
      setIsLoading(false);
      props.history.goBack();
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
    setIsLoading(false);
  }

  function buildPlaceholder(field) {
    if (field.category !== "hidden") {
      if (field.required) {
        return (
          <div>
            {field.fieldName}
            <span className="text-danger"> * </span>
          </div>
        );
      }
      return <span>{field.fieldName}</span>;
    }
  }
  function handleChangeDropdown(event) {
    let options = event.target.options;
    if (errors && errors?.autopay) {
      delete errors.autopay;
    }
    let value = [];
    let o = Object.assign({}, obj);
    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(Number(options[i].value));
      }
    }
    console.log('value', value);
    if (value.length > 2) {
      setErrors({
        ...errors,
        autopay: 'Please select only 2 days.',
      });
    }
    o.autopay = [...value];
    setObj(o);
    setIsEmpty(false);
  }
  function handleChange(e) {
    let o = Object.assign({}, obj, {
      [e.target.id]:
        e.target.id !== "permission" ? e.target.value : Number(e.target.value),
    });
    setObj(o);
    setIsEmpty(false);
    setErrors(validateForms(o, config.validationSchema, config.fieldTypes));
    if ("contributionPercent" in o) {
      let errorMessage = validateContributionPercent(o.contributionPercent);
      if (errorMessage) {
        setErrors({
          ...errors,
          contributionPercent: errorMessage,
        });
      }
    }
  }

  function validateContributionPercent(value) {
    if (!value) {
      return `Contribution Percentage is required.`;
    }
    if (Number(value) <= 0) {
      return `Contribution percentage must be greater than 0.`;
    }
    if (
      plan?.maxContribution?.percent &&
      Number(value) > plan?.maxContribution?.percent
    ) {
      return `Contribution Percentage should be less than ${plan?.maxContribution?.percent}%.`;
    }
    if (Number(value) > 100) {
      return `Contribution percentage should not exceed 100.`;
    }
    return null;
  }
  function handleChangeCheckBox(event) {
    let o = Object.assign({}, obj, {
      [event.target.id]: event.target.checked,
    });
    setObj(o);
    setIsEmpty(false);
    setErrors(validateForms(o, config.validationSchema, config.fieldTypes));
  }

  async function handleChangeDate(fieldName, selectedDate) {
    let validDate = null;
    if (fieldName === "employeeStartdate") {
      validDate = selectedDate.utc().format(Constants.DATEFORMAT.MMDDYYYY);
    } else {
      validDate = moment(selectedDate, Constants.DATEFORMAT.MMDDYYYYHH)
        .tz(props.activeCompany.timezone)
        .valueOf();
    }
    let o = Object.assign({}, obj, {
      [fieldName]: validDate,
    });

    if (type === Constants.dbTypes.OFFERING_PERIOD) {
      o = { ...o, timeZone: props.activeCompany.timezone };
    }
    setObj(o);
    setIsEmpty(false);
    setErrors(validateForms(o, config.validationSchema, config.fieldTypes));
  }

  function buildFormControl(field, key) {
    let showTime = true;
    if (field.dateformat === Constants.DATEFORMAT.MMDDYYYY) showTime = false;
    else if (field.type === "checkbox") {
      return (
        <div>
          <Form.Check
            className="tbl-checkbox"
            type="checkbox"
            label={field.fieldName}
            id={key}
          >
            <Form.Check.Input
              type="checkbox"
              onChange={handleChangeCheckBox}
              checked={obj.managed}
            />
            <Form.Check.Label></Form.Check.Label>
          </Form.Check>
        </div>
      );
    }
    if (field.type === "dropdown") {
      if (
        type === Constants.dbTypes.USER &&
        field.fieldName !== "Permissions"
      ) {
        let options = field.options;
        if (field.fieldName === "State" && obj.country && obj.country !== "") {
          options = CountryStateCodes.filter((c) => c.iso3 === obj.country)[0]
            .states;
        }
        return (
          <FormControl
            as="select"
            size="lg"
            className="form-select"
            value={obj[key]}
            onChange={handleChange}
            placeholder={field.placeholder || field.fieldName}
            readOnly={id && field.noneditable ? true : false}
          >
            {
              <option key="default" value={""}>
                {obj[key] || field.placeHolder}
              </option>
            }
            {options.map((option, index) => {
              const value = field.optionVals;
              return (
                <option key={index} value={option[value]}>
                  {option.name}
                </option>
              );
            })}
          </FormControl>
        );
      }
      let options = field.options;
      // Check if only for some specific company
      options = options.filter(
        (o) =>
          !o.companyId ||
          (o.companyId && o.companyId === props.activeCompany.id)
      );
      if (key === 'autopay') {
        return (
          <>
            <FormControl
              as="select"
              size="lg"
              className="form-select"
              value={obj && obj[key]}
              multiple
              onChange={handleChangeDropdown}
            >
              {options.map((f) => {
                return (
                  <option value={f.key} type={field.type}>
                    {f.value}
                  </option>
                );
              })}
            </FormControl>
            <FormText className="text-info" muted >
              Hold Ctrl to select 2 days
            </FormText>
            {errors && errors[key] && (
              <div>
                <FormText className="text-danger">
                  {errors[key]}
                </FormText>
              </div>
            )}
          </>
        );
      }
      return (
        <FormControl
          as="select"
          size="lg"
          className="form-select"
          value={obj[key]}
          onChange={handleChange}
          readOnly={id && field.noneditable ? true : false}
        >
          {options.map((f) => {
            return (
              <option value={f.key} type={field.type}>
                {f.value}
              </option>
            );
          })}
        </FormControl>
      );
    } else if (field.type === "date") {
      let date = moment(obj[key]);
      if (field.dateformat) {
        date = moment(obj[key], field.dateformat);
      }
      let timezone = props.activeCompany?.timezone
        ? props.activeCompany?.timezone
        : moment.tz();
      if (props.activeCompany?.timezone) {
        date = convertUTCDateInTimeZone(obj[key], timezone);
      }
      if (id && field.noneditable) {
        return (
          <FormControl
            disabled={true}
            value={date.format(Constants.DATEFORMAT.MMDDYYYYHH)}
          />
        );
      } else if (!field.noneditable) {
        return (
          <div>
            <Datetime
              locale={timezone}
              displayTimeZone={timezone}
              timeFormat={showTime}
              value={obj && obj[key] ? date : ""}
              isValidDate={(selectedDate) => {
                if (key === "enrollmentEndDate") {
                  if (
                    obj.enrollmentStartDate &&
                    selectedDate.isBefore(obj.enrollmentStartDate)
                  )
                    return false;
                }
                return true;
              }}
              inputProps={{
                placeholder: field.fieldName,
                disabled: false,
                readOnly: true,
              }}
              onChange={(selectedDate) => handleChangeDate(key, selectedDate)}
            />
            {errors && errors[key] && (
              <FormText className="text-danger">
                Enrollment end date must be older than Enrollment start date.
              </FormText>
            )}
          </div>
        );
      }
    }
    return (
      <FormControl
        size="lg"
        readOnly={id && field.noneditable ? true : false}
        value={obj && obj[key]}
        type={field.type}
        className="quantity"
        placeholder={field.fieldName}
        isInvalid={errors && errors[key]}
        onChange={handleChange}
      />
    );
  }
  function buildForm(obj, paramTypes) {
    if (!obj) {
      return;
    }
    let keys = Object.keys(paramTypes);
    return [{}].concat(keys).map((key, i) => {
      const field = paramTypes[key];
      if (i === 0 || field.readonly || field.category === "hidden") return;
      return (
        <FormGroup controlId={key} key={key} className="form-group">
          <FormLabel>{buildPlaceholder(field)}</FormLabel>
          {buildFormControl(field, key)}
          {field.notes && (
            <FormControl.Feedback type="valid">
              {field.notes}
            </FormControl.Feedback>
          )}
          <FormControl.Feedback type="invalid">
            {errors && errors[key]}
          </FormControl.Feedback>
        </FormGroup>
      );
    });
  }

  return (
    <div className="container NewNote p5">
      {!props.pageLoading && (
        <Row>
          <Col></Col>
          <Col xs={12} md={6} xl={4}>
            <Card>
              <Card.Body>
                <Card.Title as="h2">
                  {id
                    ? type && type !== Constants.dbTypes.OFFERING_PERIOD
                      ? `Edit ${type}`
                      : `Edit Offer Period`
                    : type && type !== Constants.dbTypes.OFFERING_PERIOD
                      ? `Create ${type}`
                      : `Create Offer Period`}
                </Card.Title>

                <Form
                  noValidate
                  validated={!(errors && Object.keys(errors).length > 0)}
                  onSubmit={handleSubmit}
                >
                  {buildForm(obj, config.fieldTypes)}
                  {type === Constants.dbTypes.OFFERING_PERIOD && (
                    <p>
                      NOTE: Period will be created in{" "}
                      {props.activeCompany?.timezone} timezone
                    </p>
                  )}
                  <LoaderButton
                    id="action"
                    type="submit"
                    size="lg"
                    variant="primary"
                    isLoading={isLoading}
                    className="me-2"
                    disabled={errors && Object.keys(errors).length > 0}
                  >
                    Submit
                  </LoaderButton>
                  <Button
                    id="cancel"
                    size="lg"
                    variant="outline-cancel"
                    onClick={(e) => props.history.goBack()}
                  >
                    Cancel
                  </Button>
                  {config.actionDelete ? (
                    <LoaderButton
                      id="delete"
                      isLoading={isLoading}
                      variant="outline-cancel"
                      className="pull-right"
                      onClick={showConfirm}
                    >
                      <IconContext.Provider value={{ color: "gray" }}>
                        <MdDeleteForever
                          className="trash"
                          size={28}
                        ></MdDeleteForever>
                      </IconContext.Provider>
                    </LoaderButton>
                  ) : null}
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col></Col>
        </Row>
      )}
    </div>
  );
}
